var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-container"},[_c('div',{staticClass:"descriptive-link is-paddingless is-radiusless",attrs:{"role":"link"},on:{"click":_vm.navigate}},[_c('div',{staticClass:"icon-container"},[_vm._t("icon")],2),_c('div',{staticClass:"description-container is-padded-small has-text-centered"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }